<template>
  <div class="flex flex-col gap-16 p-24">
    <BittsCallout
      type="warning"
      title="Copy this key now"
      subtitle="It won't be shown again after you leave this page."
    />
    <div
      class="inline-flex items-center gap-8 bg-neutral-background-weak rounded-lg px-12 py-10 font-mono text-sm text-neutral-text-strong w-full"
    >
      <code class="truncate flex-1">
        {{ isRevealed ? rawKey : maskedKey }}
      </code>
      <BittsButton
        type="neutral"
        variant="ghost"
        size="x-small"
        :center-icon="['fas', isRevealed ? 'eye-slash' : 'eye']"
        :aria-label="isRevealed ? 'Hide API key' : 'Reveal API key'"
        @click="isRevealed = !isRevealed"
      />
      <BittsButton
        type="neutral"
        variant="ghost"
        size="x-small"
        :center-icon="hasCopied ? ['fas', 'check'] : ['fak', 'copy']"
        aria-label="Copy API key"
        @click="copy(rawKey)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsButton, BittsCallout } from '@crossbeam/bitts';

import { computed, ref } from 'vue';

import { useCopyToClipboard } from '@/composables/useCopyToClipboard';

const { rawKey } = defineProps<{ rawKey: string }>();

const isRevealed = ref(false);
const { hasCopied, copy } = useCopyToClipboard();

const maskedKey = computed(() => '•'.repeat(rawKey.length));
</script>
